import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

// ✅ Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDJncECP4a2eC4qrTOmhD830CG3IEzO6v8",
  authDomain: "eyecare-website-d64a6.firebaseapp.com",
  projectId: "eyecare-website-d64a6",
  storageBucket: "eyecare-website-d64a6.firebasestorage.app",
  messagingSenderId: "625586864355",
  appId: "1:625586864355:web:112cda2ec19f89e42185d6",
  measurementId: "G-K22HS4YSVP"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // ✅ Allow only if UID matches
      if (user.uid === "ztuqSm9dvGcQfgwh3yxnU2U0RZA3") {
        localStorage.setItem("isAdmin", "true");
        navigate("/dashboard");
      } else {
        alert("Unauthorized access. This account is not an admin.");
      }
    } catch (error) {
      console.error("Login error:", error.message);
      alert("Invalid email or password.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <form
        onSubmit={handleLogin}
        className="bg-white p-6 rounded-lg shadow-lg w-80"
      >
        <h2 className="text-2xl font-bold mb-4 text-center">Admin Login</h2>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border w-full p-2 mb-3 rounded"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border w-full p-2 mb-3 rounded"
          required
        />
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
        >
          Login
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;
